export enum AutopayStatus {
  SUCCESS = 'success',
  WARNING = 'warning',
  ALERT = 'alert',
  INFORMATION = 'information',
}
